import React, { createContext, PropsWithChildren, useContext } from 'react';
import ThreeDotsPartSearchClaimComponents, { ThreeDotsPartSearchClaimComponentsKeys } from '.';

interface ThreeDotsPartClaimContextProps {
  anchorEl: HTMLElement | null;
  generateIdMenu: (id: string) => string;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  closeThreeDotsPartClaim: () => void;
  hideOption: (option: ThreeDotsPartSearchClaimComponentsKeys) => void;
}

const ThreeDotsPartClaimContext = createContext<ThreeDotsPartClaimContextProps | undefined>(undefined);

export const useThreeDotsPartClaimContext = () => {
  const context = useContext(ThreeDotsPartClaimContext);
  if (!context) {
    throw new Error(
      'useThreeDotsPartClaimContext must be used within a ThreeDotsPartClaimProvider'
    );
  }
  return context;
};

interface IThreeDotsPartClaimProviderProps {
  idScreen: string;
}
export const ThreeDotsPartClaimProvider: React.FC<PropsWithChildren<IThreeDotsPartClaimProviderProps>> = ({
  children,
  idScreen,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [hiddenOptions, setHiddenOptions] = React.useState<ThreeDotsPartSearchClaimComponentsKeys[]>([]);

  function closeThreeDotsPartClaim() {
    setAnchorEl(null);
  }

  function hideOption(option: ThreeDotsPartSearchClaimComponentsKeys) {
    const isHidden = hiddenOptions.includes(option);
    if (isHidden) return;

    setHiddenOptions((prev) => {
      const newSet = new Set(prev);
      newSet.add(option);
      return Array.from(newSet);
    });
  }

  const generateIdMenu = (id: string) => `${idScreen}-menu-${id}`;

  const TOTAL_OPTIONS = Object.keys(ThreeDotsPartSearchClaimComponents).length - 1;
  const TOTAL_OPTIONS_HIDDEN = hiddenOptions.length;

  if (TOTAL_OPTIONS_HIDDEN === TOTAL_OPTIONS) return null;
  return (
    <ThreeDotsPartClaimContext.Provider
      value={{
        anchorEl,
        hideOption,
        generateIdMenu,
        setAnchorEl,
        closeThreeDotsPartClaim
      }}
    >
      {children}
    </ThreeDotsPartClaimContext.Provider>
  );
};
